import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  FullCard,
  Spinner,
  Button,
} from "../components/CommonComponents";
import SpinnerButton from "../components/spinnerButton";
import { FileUploadOcr } from "../components/Fileupload";
import { MdOutlineFileDownload, MdOutlineEdit } from "react-icons/md";
import { pdfjs, Document, Page } from "react-pdf";
import { download } from "../utils";
import { handwritten, scanned } from "../api/serverAPI";
import { LuX } from "react-icons/lu";
import ImageEditorModal from "../components/ImageEditor/_imageEditor";
import { FaRegKeyboard } from "react-icons/fa6";
import lang from "../utils/lang";
import VKeyboard from "../components/vkeyboard2";
import VKeyboardScanned from "../components/vkeyboard";
import { Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { saveAs } from "file-saver";
import EditablePdfViewer from "../components/EditablePdfViewer";
import Editor from "../components/PDFEditor/Editor.jsx";
import PdfEditor from "../components/PDFEditor/pdfEditor";
import Store from "../components/PDFEditor/store";
import FileViewer from "../components/PDFEditor/FileViewer.jsx";

export const Ocr = () => {
  const textAreaRefs = useRef([]);
  const editorRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [editorchange, seteditorchange] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ocrType, setOcrType] = useState("");
  const fileInputRef = useRef(null);
  const [filesData, setFilesData] = useState(null);
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [language, setLanguage] = useState("");
  const [selectedType, setSelectedType] = useState("source");
  const [targetcard, setTargetCard] = useState(false);
  const [gramCorr, setGramCorr] = useState(true);
  const [base64Data, setBase64Data] = useState([]);
  const [output, setOutput] = useState([]);
  const [edit, setEdit] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [openKeyboard, setOpenKeyboard] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [fileExt, setFileExt] = useState("");
  const editModal = useRef();
  const [pdfUrl, setPdfUrl] = useState("");
  const cursorPositions = useRef([]);
  const [file, setFile] = useState([]);
  const [documentId, setDocumentId] = useState("");
  const acceptTypes = ["jpeg", "jpg", "png"];
  const [editedFilesData, setEditedFilesData] = useState(null);
  const [imageFile, setImageFile] = useState([]);
  const [editedImageFile, setEditedImageFile] = useState([]);

  useEffect(() => {
    if (!edit) {
      setOpenKeyboard(false);
    }
  }, [edit]);

  const handleChange = (e, index) => {
    // Save cursor position before the update
    const cursorPosition = e.target.selectionStart;
    // Update the output value
    const newOutput = [...output];
    newOutput[index] = e.target.value;
    setOutput(newOutput);
    setTimeout(() => {
      const textArea = textAreaRefs.current[index];
      if (textArea) {
        textArea.selectionStart = cursorPosition;
        textArea.selectionEnd = cursorPosition;
        textArea.focus();
      }
    }, 0);
  };

  useEffect(() => {
    // After the state updates and the component re-renders, restore the cursor position
    output.forEach((_, index) => {
      if (
        textAreaRefs.current[index] &&
        cursorPositions.current[index] !== undefined
      ) {
        textAreaRefs.current[index].setSelectionRange(
          cursorPositions.current[index],
          cursorPositions.current[index]
        );
      }
    });
  }, [output]);

  const isExtractButtonVisible =
    selectedFile && ocrType && language && progress === 100;

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const setSource = () => {
    setSelectedType("source");
  };

  const setTarget = () => {
    setSelectedType("target");
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const goToPreviousPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };
  
  const handleRemoveFile = (fileToRemove) => {
    setFilesData((prevFiles) => {
      const updatedFiles = prevFiles.filter(
        (file) => file.id !== fileToRemove.id
      );

      if (updatedFiles.length === 0) {
        resetFileStates();
      }

      return updatedFiles;
    });

    setEditedFilesData((prevFiles) =>
      prevFiles.filter((file) => file.id !== fileToRemove.id)
    );

    setBase64Data((prevBase64Data) =>
      prevBase64Data.filter(
        (_, index) =>
          filesData.findIndex((file) => file.id === fileToRemove.id) !== index
      )
    );

    if (selectedFile && selectedFile.id === fileToRemove.id) {
      resetFileStates();
    }
  };

  const resetFileStates = () => {
    setSelectedFile(null);
    setProgress(0);
    setOutput([]);
    setOpenKeyboard(false);
    setBase64Data([]);
    setSelectedType("");

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    setSelectedFile(files[0]); // Keep the first file as selected for single-file operations
    setBase64Data([]);
    setProgress(0);
    setOutput([]);
    setOpenKeyboard(false);
    setSelectedType("source");

    const updatedFilesData = [];
    const updatedEditedFilesData = [];

    files.forEach((file, index) => {
      const reader = new FileReader(); // Create a new FileReader for each file
      reader.onload = () => {
        const base64String = reader.result.split(",")[1];
        const fileData = {
          ...file,
          file,
          data: base64String,
          id: `file-${index}`, // Generate unique ID for each file
          type: file.type || "image/png",
          lastModified: file.lastModified,
          name: file.name,
        };

        updatedFilesData.push(fileData);
        updatedEditedFilesData.push(fileData);

        if (updatedFilesData.length === files.length) {
          // Set state only after processing all files
          setFilesData(updatedFilesData);
          setEditedFilesData(updatedEditedFilesData);
          setBase64Data(updatedFilesData.map((file) => file.data)); // Store base64 data of all files
        }
      };

      reader.readAsDataURL(file); // Start reading the current file
      const fileExtension = getFileExtension(file.name);
      if (index === 0) setFileExt(fileExtension); // Set the extension for the first file
    });

    // Handle progress for multiple files
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress < 100) {
          return prevProgress + 10;
        } else {
          clearInterval(interval);
          return 100;
        }
      });
    }, 500);
  };

  const handleDownload = () => {
    if (!output || output.length === 0) return;

    const combinedText = output.join("\n\n");

    const baseFilename =
      selectedFile.name.split(".").slice(0, -1).join("") || `output`;
    const filename = `${baseFilename}.txt`;

    const blob = new Blob([combinedText], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleEdit = () => {
    setIsEditMode((prevMode) => !prevMode);
  };

  function getFileExtension(filename) {
    return filename.split(".").pop().toLowerCase();
  }

  const handleSubmit = async () => {
    setLoading(true);
    try {
      let payload, out;
      if (ocrType === "handwritten") {
        payload = {
          uid: "1",
          files: base64Data,
          filename: selectedFile.name,
          source_language: language,
          grammar_correction: isChecked ? "true" : "false",
        };

        const response = await handwritten(payload);
        out = Object.values(response.data);
        setOutput(out);
        setTargetCard(true);
      } else if (ocrType === "scanned") {
        payload = {
          file: base64Data[0],
          filename: selectedFile.name,
          user_id: "1",
          document_type: "ocr",
          organisation_id: "1",
          source_language: language,
          named_entities: "retain",
          other_entities: "retain",
          salutations: "retain",
          target_language: "ta",
        };

        const response = await scanned(payload);

        const documentId = response.data.result.document_id;
        
        const generatedUrl = `https://document-translation.s3.ap-south-1.amazonaws.com/converted_files/${documentId}.pdf`;
        console.log(generatedUrl);
        setPdfUrl(generatedUrl);

        setDocumentId(documentId);
        setTargetCard(true);
      }
    } catch (error) {
    } finally {
      setLoading(false);
      setSelectedType("target");
    }
  };

  const overlayStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100vw",
    position: "fixed",
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    zIndex: 1000,
  };

  useEffect(() => {
    if (!filesData) {
      setOutput([]);
      return setEditedFilesData(null);
    }
    const editedFiles = filesData.map(
      (file) =>
        editedFilesData?.find?.((editedFile) => editedFile?.id === file.id) ||
        file
    );
    setEditedFilesData(editedFiles);
  }, [filesData]);

  const DisplayOutput = () => (
    (
      <div>
        <ImageEditorModal
          ref={editModal}
          filesData={filesData}
          editedFilesData={editedFilesData}
          onChange={setEditedFilesData}
          setFilesData={setFilesData}
          acceptTypes={acceptTypes}
        />
        <Card>
          {fileExt === "pdf" ? (
            <div className="my-6g">
              <div className="border-2 border-[#23479F] rounded-lg">
                <div className="bg-[#23479F] p-4 flex justify-between items-center">
                  <div className="flex gap-3">
                    <Button size="white" onClick={setSource}>
                      Source
                    </Button>
                    <Button size="white" onClick={setTarget}>
                      Target
                    </Button>
                  </div>
                  <div className="flex gap-3 text-2xl text-white">
                    {selectedType === "target" && (
                      <>
                        {ocrType === "handwritten" && (
                          <>
                            {" "}
                            <MdOutlineFileDownload
                              className="cursor-pointer"
                              onClick={handleDownload}
                            />
                            <MdOutlineEdit
                              className="cursor-pointer"
                              onClick={handleEdit}
                            />
                            <FaRegKeyboard
                              className="cursor-pointer"
                              style={{ marginBottom: "6px" }}
                              onClick={() => {
                                setOpenKeyboard(!openKeyboard);
                              }}
                            />
                          </>
                        )}
                        {ocrType === "scanned" && (
                          <>
                            {" "}
                            <MdOutlineEdit
                              className="cursor-pointer"
                              onClick={() => {
                                if (document) {
                                  Store.update("doc-editor", {
                                    docId: documentId,
                                    type: "pdf",
                                  });
                                }
                                setEdit(!edit);
                              }}
                            />
                            {edit ? (
                              <FaRegKeyboard
                                className="cursor-pointer"
                                style={{ marginBottom: "6px" }}
                                onClick={() => {
                                  setOpenKeyboard(!openKeyboard);
                                }}
                              />
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>

                {selectedType === "source" && (
                  <>
                    <div className="w-full h-[70vh] overflow-y-auto">
                      <div>
                        <Document
                          file={selectedFile}
                          onLoadSuccess={onDocumentLoadSuccess}
                        >
                          <Page className="p-4" pageNumber={pageNumber} />
                        </Document>

                        <div className="p-1 flex justify-center space-x-2 mt-2">
                          <button
                            className="text-sm text-white rounded-lg bg-sky-800 p-1"
                            onClick={goToPreviousPage}
                            disabled={pageNumber <= 1}
                          >
                            Prev
                          </button>
                          <span>
                            Page {pageNumber} of {numPages}
                          </span>
                          <button
                            className="text-sm text-white rounded-lg bg-sky-800 p-1"
                            onClick={goToNextPage}
                            disabled={pageNumber >= numPages}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                      {/* <FileViewer
                  // browser
                  // ref={upload}
                  onMount={(file) => {
                      setFilesData(file);                   
                  }}
                  
                  type="pdf"
                  file={filesData.map((file) => ({
                    ...file,
                    data: `data:${file.type};base64,${file.data}`,
                  }))}
                  url=""
                  acceptTypes={acceptTypes}
                /> */}
                    </div>
                  </>
                )}

                {selectedType === "target" && ocrType === "handwritten" && (
                  <div className="h-[70vh] flex flex-col">
                    {output?.length > 0 && (
                      <div className="flex flex-col h-full gap-4 bg-[#ededed] items-center p-2 overflow-auto">
                        {output.map((text, index) => (
                          <div
                            key={`output-${index}`}
                            className="w-[90%] h-fit outline-none resize-none bg-[#fff] shadow-[0_1px_6.5px_0_#224b9923] p-8"
                          >
                            <textarea
                              ref={(el) => (textAreaRefs.current[index] = el)}
                              className="w-full outline-none resize-none bg-transparent overflow-auto"
                              style={{ height: "auto", minHeight: "100vh" }}
                              value={text}
                              onChange={(e) => handleChange(e, index)}
                              readOnly={!isEditMode}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                    <VKeyboard
                      open={openKeyboard}
                      layout={
                        lang.find((d) => d.value === language)?.keyboardLayout
                      }
                    />
                  </div>
                )}
                {selectedType === "target" && ocrType === "scanned" && (
                  <div className="w-full h-[70vh] flex flex-col">
                    {documentId && (
                      <>
                        <div className="flex-grow">
                          <Editor
                            ref={editorRef}
                            type="pdf"
                            docId={documentId}
                            readOnly={!edit}
                            onSelectLang={language}
                            onShowKeyboard={setShowKeyboard}
                            // changedetect={seteditorchange}
                          />
                        </div>
                        <VKeyboardScanned
                          open={openKeyboard}
                          layout={
                            lang.find((d) => d.value === language)
                              ?.keyboardLayout
                          }
                          ctx={window.pdfDoc}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="my-6g">
              <div className="border-2 border-[#23479F] rounded-lg">
                <div className="bg-[#23479F] p-4 flex justify-between items-center">
                  <div className="flex gap-3">
                    <Button size="white" onClick={setSource}>
                      Source
                    </Button>
                    <Button size="white" onClick={setTarget}>
                      Target
                    </Button>
                  </div>
                  <div className="flex gap-3 text-2xl text-white">
                    {selectedType === "source" && (
                      <>
                        <MdOutlineEdit
                          className="cursor-pointer"
                          onClick={() =>
                            //  filesData &&
                            editModal.current.showModal()
                          }
                        />
                      </>
                    )}
                    {selectedType === "target" && (
                      <>
                        <MdOutlineFileDownload
                          className="cursor-pointer"
                          onClick={handleDownload}
                        />
                        {ocrType === "handwritten" && (
                          <>
                            <MdOutlineEdit
                              className="cursor-pointer"
                              onClick={handleEdit}
                            />
                            <FaRegKeyboard
                              className="cursor-pointer"
                              style={{ marginBottom: "6px" }}
                              onClick={() => {
                                setOpenKeyboard(!openKeyboard);
                              }}
                            />
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>

                {selectedType === "source" && (
                  <div className="w-full h-[70vh] overflow-y-auto">
                    {/* <img
                    src={
                      typeof selectedFile === "string"
                        ? selectedFile
                        : URL.createObjectURL(selectedFile)
                    }
                    className="max-w-full max-h-screen p-4"
                  /> */}
                    <FileViewer
                      type="png"
                      onMount={(file) => {
                        setFilesData(file);
                      }}
                      file={editedFilesData.map((file) => ({
                        ...file,
                        data: `data:${file.type};base64,${file.data}`,
                      }))}
                      acceptTypes={acceptTypes}
                      url=""
                    />
                  </div>
                )}

                {selectedType === "target" && ocrType === "handwritten" && (
                  <div className="h-[70vh] flex flex-col">
                    {output?.length > 0 && (
                      <div className="flex flex-col h-full gap-4 bg-[#ededed] items-center p-2 overflow-auto">
                        {output.map((text, index) => (
                          <div
                            key={`output-${index}`}
                            className="w-[90%] h-fit outline-none resize-none bg-[#fff] shadow-[0_1px_6.5px_0_#224b9923] p-8"
                          >
                            <textarea
                              ref={(el) => (textAreaRefs.current[index] = el)}
                              className="w-full outline-none resize-none bg-transparent overflow-auto"
                              style={{ height: "auto", minHeight: "100vh" }}
                              value={text}
                              onChange={(e) => handleChange(e, index)}
                              readOnly={!isEditMode}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                    <VKeyboard
                      open={openKeyboard}
                      layout={
                        lang.find((d) => d.value === language)?.keyboardLayout
                      }
                    />
                  </div>
                )}
                {selectedType === "target" && ocrType === "scanned" && (
                  <>
                   <div className="flex-grow">
                   <Editor
                     ref={editorRef}
                     type="pdf"
                     docId={documentId}
                     readOnly={!edit}
                     onSelectLang={language}
                     onShowKeyboard={setShowKeyboard}
                     // changedetect={seteditorchange}
                   />
                 </div>
                 <VKeyboardScanned
                   open={openKeyboard}
                   layout={
                     lang.find((d) => d.value === language)
                       ?.keyboardLayout
                   }
                   ctx={window.pdfDoc}
                 />
                 </>
                )}
              </div>
            </div>
          )}
        </Card>
      </div>
    )
  );

  return (
    <div className="flex gap-4 overflow-y-hidden">
      {loading && (
        <div style={overlayStyle}>
          <Spinner />
        </div>
      )}

      <div className="secondcardWidth">
        <FullCard>
          <div className="subheading text-center mt-2">OCR</div>
          <div className="text-center my-4">
            <FileUploadOcr
              multiple
              accept="application/pdf, image/jpeg, image/png"
              onChange={handleFileChange}
              ref={fileInputRef}
              //  multiple
            />

            {progress > 0 && progress < 100 && (
              <div className="my-4 flex flex-col items-center">
                <div className="bg-[#D2CFF1] h-4 rounded-full w-[15vw]">
                  <div
                    className="bg-[#23479F] h-full rounded-full"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
                <div className="text-center mt-2 w-[15vw]">{`${progress}% Complete`}</div>
              </div>
            )}

            {progress > 0 && filesData.length > 0 && (
              <div className="text-gray-700 mt-4">
                <strong>Uploaded Files:</strong>
                <ul className="mt-2 ml-14 mr-0">
                  {filesData.map((file, index) => (
                    <li
                      key={file.id}
                      className="flex items-center justify-between w-[10vw] mt-2"
                    >
                      <span>{file.name}</span>
                      <button
                        onClick={() => {
                          handleRemoveFile(file);
                          setOutput([]);
                        }}
                        className=" text-black"
                      >
                        <LuX />
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="my-8 px-6">
              <label className="text-lg font-medium text-indigo-800 text-left my-2">
                Choose OCR Type
              </label>
              <select
                className="inline-flex w-full rounded-md border px-4 py-2 text-sm"
                value={ocrType}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setOcrType(selectedValue);
                  if (selectedValue === "scanned") {
                    setGramCorr(false);
                  }
                  if (selectedValue === "handwritten") {
                    setGramCorr(true);
                  }
                }}
              >
                <option value="" hidden>
                  Select OCR Type
                </option>
                <option value="handwritten">Hand Written</option>
                <option value="scanned">Scanned</option>
              </select>
            </div>

            <div className="my-8 px-6">
              <label className="text-lg font-medium text-indigo-800 text-left my-2">
                Select Language
              </label>
              <select
                className="inline-flex w-full rounded-md border px-4 py-2 text-sm"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
              >
                <option value="" hidden>
                  Select Language
                </option>
                <option value="as">Assamese</option>
                <option value="bn">Bengali</option>
                <option value="en">English</option>
                <option value="gu">Gujarati</option>
                <option value="hi">Hindi</option>
                <option value="kn">Kannada</option>
                <option value="ml">Malayalam</option>
                <option value="mni">Manipuri</option>
                <option value="mr">Marathi</option>
                <option value="or">Odia</option>
                <option value="pa">Punjabi</option>
                <option value="sd">Sindhi</option>
                <option value="ta">Tamil</option>
                <option value="te">Telugu</option>
                <option value="ur">Urdu</option>
              </select>
            </div>

            {gramCorr && (
              <div className="w-full my-4 px-6 flex items-center space-x-2">
                <label className="inline-flex items-center space-x-2">
                  <input
                    type="checkbox"
                    className="form-checkbox h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring focus:ring-blue-300"
                    name="grammarCorrection"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <span className="text-sm leading-5 font-medium text-gray-800">
                    Grammar Correction
                  </span>
                </label>
              </div>
            )}

            {isExtractButtonVisible && (
              <div className="flex justify-center my-8">
                <Button
                  size="medium"
                  color="light-purple"
                  type="submit"
                  disabled={loading}
                  onClick={handleSubmit}
                >
                  {loading ? (
                    <SpinnerButton size="sm" colour="white" />
                  ) : (
                    "Extract"
                  )}
                </Button>
              </div>
            )}
          </div>
        </FullCard>
      </div>

      <div className="thirdcardWidth overflow-y-auto h-[90vh]">
        {progress === 100 && (
          <Card>
            <DisplayOutput />
          </Card>
        )}
      </div>
    </div>
  );
};

export default Ocr;
